<template>
    <span>
        <span
            v-if="isExpanded"
            class="mr-1"
        >
            <slot> </slot>
        </span>
        <BasicButton
            class="!p-0 font-light"
            :is-link="true"
            color="info"
            size="m"
            :uppercase="false"
            @click="isExpanded = !isExpanded"
        >
            <span> {{ buttonText }} </span>
            <BasicIcon
                class="ml-1 fill-info transition-transform duration-300"
                :class="{ 'rotate-180': !isExpanded }"
                name="triangle_up"
                size="8"
            >
            </BasicIcon>
        </BasicButton>
    </span>
</template>

<script setup lang="ts">
import BasicButton from '@atoms/BasicButton/BasicButton.vue';
import BasicIcon from '@atoms/BasicIcon/BasicIcon.vue';

const isExpanded = ref(false);

const { t } = useI18n();

const translations = computed(() => {
    return {
        expand: t('atp.button.expand'),
        collapse: t('atp.button.collapse'),
    };
});

const buttonText = computed(() => {
    return isExpanded.value
        ? translations.value.collapse
        : translations.value.expand;
});
</script>
